/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Scope_Org_HintInputs */



/**
* | output |
* | --- |
* | "Everyone in your organization can see and use this persona." |
*
* @param {Personas_Scope_Org_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_scope_org_hint = /** @type {((inputs?: Personas_Scope_Org_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Scope_Org_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle in deiner Organisation können diese Persona sehen und verwenden.")
	return /** @type {LocalizedString} */ ("Everyone in your organization can see and use this persona.")
});